import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import Close from '~/shared/assets/icons/Close'
import Button from '~/shared/components/buttons/Button'
import { isModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function PaymentCancelCompletedModal() {
  const [isModalOpen, setIsModalOpen] = useRecoilState(isModalOpenState)

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <CloseIcon
        onClick={() =>
          setIsModalOpen({ ...isModalOpen, contents: '', isOpen: false })
        }
      />
      <MainText>결제 취소 완료</MainText>
      <Desc>환불처리는 영업 기준 2~3일정도 소요될 수 있습니다.</Desc>
      <StyledButton
        $width={92}
        $height={52}
        $fontSize={18}
        $variant="black"
        onClick={() => {
          window.location.reload()
        }}
      >
        확인
      </StyledButton>
    </Wrapper>
  )
}

export default PaymentCancelCompletedModal

const Wrapper = styled.section`
  position: fixed;
  z-index: ${theme.zIndex.modal};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  box-sizing: border-box;
  min-width: 30%;
  margin: 0 auto;
  padding: 108px 77px 60px;

  background-color: ${theme.colors.white};
  border-radius: 12px;

  @media ${theme.device.medium} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    box-sizing: border-box;
    width: 90%;
    padding: 56px 20px 30px;
  }
`

const CloseIcon = styled(Close)`
  position: absolute;
  top: 36px;
  right: 36px;

  @media ${theme.device.medium} {
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
`

const MainText = styled.h1`
  width: ${theme.calculatePcVw(580)};

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 42px;
  font-weight: 500;
  line-height: 140%;
  text-align: center;

  @media ${theme.device.medium} {
    width: 80%;
    height: 100px;

    font-size: 36px;
    font-weight: 500;
    line-height: 140%;
  }
`

const Desc = styled.p`
  width: 80%;
  height: 75px;
  line-height: 30px;
  text-align: center;
`

const StyledButton = styled(Button)`
  width: 100%;
  color: ${theme.colors.white};
  background-color: ${theme.colors.grey_5};
`
